import type { InjectionKey } from 'vue'
import type { AccordionState } from './types'

export const ACCORDION_KEY = Symbol() as InjectionKey<AccordionState>
